var _defs, _g, _path, _polygon, _polygon2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChaiseRoues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_8",
    "data-name": "Calque 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 864 1085.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#303030;}.cls-4{fill:#262626;}.cls-5{fill:#725aff;}.cls-6{fill:#a3a3a3;}.cls-7{stroke:#a3a3a3;stroke-miterlimit:10;stroke-width:7px;}.cls-8{fill:#4d47bf;}.cls-9{fill:#dbdbdb;}.cls-10{fill:#7a7a7a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-763 -593)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1538,1529h-14c-.42-12.07-.62-24.39-4-33-9.82-10.87-60-23-109-35,3.23-22.38.29-37.23-15-37v-20c-.82-6.67-5.57-9.63-12-11-50.27-5.48-112,1-179,13V1239l-16-6v-77h6l1-22c52-10,101.91-29.6,150-33,42.49-4,72.67-12.16,98-22,18.84-27.06,33.1-90.12,47-156l-8-234c.23-39.87-16.09-63.52-52-68l-226-5c-35.81,4-61.46,26.35-82,58-21.35,47.21-41.63,129.55-62,209-14.45,49.06-48.49,95-95,139-70.83,4-133.38,12-130,52,48.76,53.48,145,66,237,66,14.49,10.4,33,12.27,54,9h27v8h5v75l-15,7v165c-35.1-9.2-86.46-13.83-143-17-11.4,0-17.79,4.57-21,12v23c-21.32,1.74-27,12-27,30-46.61,10.49-130,32-130,41-4.67,0-4.67,29,0,29l-1,26c-6,44,12,55.19,31.56,55.19-.21-2.33,18.52-4,18.73-1.68,15.71,0,23.39-13,24.71-31.51,0-30-9-41-33-41-1.18.78,0-6,0-6l7-2v-11c71.8-20.39,153.73-26.55,253-17a29.39,29.39,0,0,0,16,7l-7,93,4,4-1,26,19,27c6.62,40.31,73.62,29.31,67-11h3c-3-24.14-17-38.25-39-45l7-84c3-8,23-16,34-16,89-5,168-1,244,22,.23,5.79,1.3,10.58,6,11v19c-8.07,18.66-4.73,36.1,13,52,4.29,1.37,7.46,1.13,10,0,10-4,19-4.13,19,0a22.89,22.89,0,0,0,13,0C1553,1588,1559,1537,1538,1529Zm-516-92v-17q22.93,2.3,38,9Zm327,0v9l-51-12,54-11,3,8Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chaise \xE0 roues") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1538,1529h-14c-.42-12.07-.62-24.39-4-33-9.82-10.87-60-23-109-35,3.23-22.38.29-37.23-15-37v-20c-.82-6.67-5.57-9.63-12-11-50.27-5.48-112,1-179,13V1239l-16-6v-77h6l1-22c52-10,101.91-29.6,150-33,42.49-4,72.67-12.16,98-22,18.84-27.06,33.1-90.12,47-156l-8-234c.23-39.87-16.09-63.52-52-68l-226-5c-35.81,4-61.46,26.35-82,58-21.35,47.21-41.63,129.55-62,209-14.45,49.06-48.49,95-95,139-70.83,4-133.38,12-130,52,48.76,53.48,145,66,237,66,14.49,10.4,33,12.27,54,9h27v8h5v75l-15,7v165c-35.1-9.2-86.46-13.83-143-17-11.4,0-17.79,4.57-21,12v23c-21.32,1.74-27,12-27,30-46.61,10.49-130,32-130,41-4.67,0-4.67,29,0,29l-1,26c-6,44,12,55.19,31.56,55.19-.21-2.33,18.52-4,18.73-1.68,15.71,0,23.39-13,24.71-31.51,0-30-9-41-33-41-1.18.78,0-6,0-6l7-2v-11c71.8-20.39,153.73-26.55,253-17a29.39,29.39,0,0,0,16,7l-7,93,4,4-1,26,19,27c6.62,40.31,73.62,29.31,67-11h3c-3-24.14-17-38.25-39-45l7-84c3-8,23-16,34-16,89-5,168-1,244,22,.23,5.79,1.3,10.58,6,11v19c-8.07,18.66-4.73,36.1,13,52,4.29,1.37,7.46,1.13,10,0,10-4,19-4.13,19,0a22.89,22.89,0,0,0,13,0C1553,1588,1559,1537,1538,1529Zm-516-92v-17q22.93,2.3,38,9Zm327,0v9l-51-12,54-11,3,8Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1159,1157h34l128-6,149-77s-72-9-74-9-311,20-311,20l-101,34,46,38s42,3,45,4S1159,1157,1159,1157Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1067.67,1140s70.33-8,97.33-16,130-40,176-40,106-2,118-7,168-252,168-252L1492,593l-395,12L763,1146l259,37Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1145,1420c0,15.36,61,15.36,61,0V1239l-17-83-31.75,1.11L1125,1338l20,55Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1189.58,
    cy: 1645.02,
    rx: 32.43,
    ry: 29.67,
    transform: "translate(-1426.14 222.18) rotate(-30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M820.88,1560.84C828,1537,844,1543,849.5,1572.5c1,18.68-3.94,26.85-16.5,21.5l-8.19-7.73S831,1599,832,1600s12.75,2.32,12.75,2.32C856.65,1598.4,858,1586,858,1574s-6.17-33.34-20-37c-7.27.25-13.21,5.87-16,13l-5,9,2,7Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1519,1598c-7.26-7-11-17.29-12-30,5.31,1.62,9-10.5,13-20,0,0,7-17,17-14a23.82,23.82,0,0,1,14,12l4,43-26,13Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1524,1571c4-32,27-46,25-5C1548,1595,1521,1600,1524,1571Z",
    transform: "translate(-763 -593)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1503.38,1596.78C1508,1593,1509,1590,1509,1586l-4-9c-13.33,3.88-20.26-4.5-24-19l-6-18-14,49,14,19h25Z",
    transform: "translate(-763 -593)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1070,872c-15,89,52,158.29,177,183,57,10,90,14,159,7,39.78-29.44,65.54-74.09,80-131l-14-247c-.34-35.29-16.4-53.5-46-57l-209-7c-36.86-1-67,21.18-93,58C1124,678,1085,783,1070,872Z",
    transform: "translate(-763 -593)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "408.52 838.42 409 659 422 659 422 838.42 408.52 838.42"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "409 648 409 564 415.26 564 415 648 409 648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1144,1239c0,17.33,61,17.33,61,0l-16-6c-.38,11.41-30.38,10.41-30-1Z",
    transform: "translate(-763 -593)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaiseRoues);
export default __webpack_public_path__ + "static/media/chaise_roues.b097c8dbf3a2143d9950e595756d729a.svg";
export { ForwardRef as ReactComponent };